import "./info-card.scss";
import React from "react";

export const InfoCard = ({title, description, ...props}) =>
    <div className="info-card">
        <div className="title">{title}</div>
        <div className="description">{description}</div>
    </div>;
